var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M7.5,5.892a3.846,3.846,0,1,0,3.845,3.846A3.839,3.839,0,0,0,7.5,5.892Zm0,6.346a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,7.5,12.238Zm4.9-6.5a.9.9,0,1,1-.9-.9A.895.895,0,0,1,12.4,5.735Zm2.547.91A4.44,4.44,0,0,0,13.731,3.5,4.467,4.467,0,0,0,10.588,2.29c-1.238-.07-4.949-.07-6.187,0A4.46,4.46,0,0,0,1.259,3.5,4.454,4.454,0,0,0,.047,6.642c-.07,1.238-.07,4.95,0,6.189a4.44,4.44,0,0,0,1.211,3.143A4.472,4.472,0,0,0,4.4,17.185c1.238.07,4.949.07,6.187,0a4.438,4.438,0,0,0,3.142-1.212,4.469,4.469,0,0,0,1.211-3.143c.07-1.238.07-4.947,0-6.185Zm-1.6,7.514a2.531,2.531,0,0,1-1.426,1.426,16.524,16.524,0,0,1-4.421.3,16.653,16.653,0,0,1-4.421-.3A2.531,2.531,0,0,1,1.65,14.159a16.535,16.535,0,0,1-.3-4.422,16.664,16.664,0,0,1,.3-4.422A2.531,2.531,0,0,1,3.076,3.89a16.524,16.524,0,0,1,4.421-.3,16.653,16.653,0,0,1,4.421.3,2.531,2.531,0,0,1,1.426,1.426,16.535,16.535,0,0,1,.3,4.422A16.525,16.525,0,0,1,13.342,14.159Z",
    transform: "translate(0.005 -2.238)",
    fill: "#666262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0622b31201c0c92db1f05ce0610663b3.svg";
export { ForwardRef as ReactComponent };